import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import {
  addCustomerToUserReducer,
  addUserReducer,
  getRoleReducer,
  getUserByIDReducer,
  getUsersReducer,
  userLoginReducer,
  removeCustomerFromUserReducer,
  resetDeviceIDReducer,
  resetPasswordReducer,
  updateUserReducer,
  userLogoutReducer,
  fetchAttendanceReducer,
  resignUserReducer,
  forceLogoutUserReducer,
  forceLogoutMultipleReducer,
  getAffiliateStatsReducer,
  getAffiliateReferralsReducer,
  getAffiliateEarningsReducer,
} from './reducers/userReducers';
import {
  addCustomerReducer,
  getCustomersReducer,
  updateCustomerReducer
} from './reducers/customerReducers';
import {
  addRoleReducer,
  deleteRoleReducer,
  getRoleByIDReducer,
  getRolesReducer,
  updateRoleReducer,
} from './reducers/roleReducers';

import {
  getWalletBalanceReducer,
  getUserTransactionsReducer,
  createDepositReducer,
  createChipDepositReducer,
  createBuyInReducer,
  createCashoutReducer,
  getAllTransactionsReducer,
  updateTransactionStatusReducer,
  createAdminTransactionReducer,
  getUsersForTransactionReducer,
  getClubLedgerReducer,
} from './reducers/walletReducers'
import {
  userLoginReducer as adminLoginReducer,
  addUserReducer as addAdminReducer,
  getUsersReducer as getAdminsReducer,
  getAdminByIDReducer,
  updateUserReducer as updateAdminReducer,
  deleteAdminReducer,
  bulkDeleteAdminsReducer,
  // other admin reducers...
} from './reducers/AdminReducers';

import {
  addDailyCommissionReducer,
  getDailyCommissionsReducer,
  getDailyCommissionByIdReducer,
  updateDailyCommissionReducer,
  deleteDailyCommissionReducer,
  getCommissionSummaryReducer,
  updateEvidenceStatusReducer,
  bulkUpdateEvidenceStatusReducer,
  exportDailyCommissionsReducer,
} from './reducers/dailyCommissionReducer.js'

// ✅ ADD REPORT REDUCERS
import {
  getReportsReducer,
  getDetailedTransactionsReducer,
  setReportFilterReducer,
  exportReportsReducer,
  getAvailableClubsReducer,
  selectedClubsReducer,
} from './reducers/reportReducers.js'

// Club and Location reducers
import {
  venueListReducer,
  venueCreateReducer,
  venueAddClubReducer,
  locationListReducer,
  locationDetailsReducer,
  locationCreateReducer,
  locationUpdateReducer,
  locationDeleteReducer,
  clubListReducer,
  clubDetailsReducer,
  clubCreateReducer,
  clubUpdateReducer,
  clubDeleteReducer,
  clubStatsReducer,
  clubAssignAdminReducer,
  selectedClubReducer,
  // Chip Inventory reducers
  chipInventoryReducer,
  chipInventorySetupReducer,
  chipInventoryAddReducer,
  chipInventoryRemoveReducer,
  chipInventoryHistoryReducer,
  chipInventorySummaryReducer,
  chipInventoryReconcileReducer,
} from './reducers/clubReducers.js'

// Player Profile reducers
import {
  playerProfileReducer,
  playerSummaryReducer,
  playerTransactionsReducer,
  playerAnalyticsReducer,
  playerClubsReducer,
  playerReferralsReducer,
  freezePlayerReducer,
  playerPhoneReducer,
  listPlayersReducer,
  assignPlayerClubReducer,
  removePlayerClubReducer,
  playerRemarksReducer,
  updatePlayerRemarksReducer,
  deletePlayerReducer,
  bulkDeletePlayersReducer,
} from './reducers/playerReducer.js'



import {
  tableListReducer,
  tableDetailsReducer,
  tableCreateReducer,
  tableUpdateReducer,
  tableDeleteReducer,
} from './reducers/tableReducers.js'

// Session Management reducers
import {
  startSessionReducer,
  endSessionReducer,
  activeSessionReducer,
  sessionSummaryReducer,
} from './reducers/sessionReducers.js'

// Analytics Dashboard reducers
import {
  transactionVolumeReducer,
  revenueAnalyticsReducer,
  userGrowthReducer,
  realTimeStatsReducer,
  clubPerformanceReducer,
} from './reducers/analyticsReducer.js'

// Messaging reducers
import {
  getMessagingUsersReducer,
  sendDirectMessageReducer,
  getMessageTemplatesReducer,
  getUserMessageHistoryReducer,
  claimVoucherReducer,
  getVoucherStatusReducer,
  getMyVouchersReducer,
} from './reducers/messagingReducers.js'


// Dashboard reducers
import {
  dashboardStatsReducer,
  dashboardAdminStatsReducer,
  dashboardTutorialsReducer,
  dashboardLiveFloorReducer,
  dashboardActiveSessionsReducer,
  dashboardDealerStatusReducer,
  dashboardAlertsReducer,
  dashboardRevenueChartReducer,
  dashboardPlayerGrowthReducer,
  dashboardClubRevenueReducer,
  dashboardRecentTxnReducer,
  dashboardPendingApprovalsReducer,
  dashboardHighlightsReducer,
} from './reducers/dashboardReducers.js'

// Audit Trail reducers
import {
  auditLogsReducer,
  auditLogDetailReducer,
  auditLogStatsReducer,
  pendingReviewsReducer,
  markAsReviewedReducer,
  securityAlertsReducer,
  userActivityReducer,
  exportAuditLogsReducer,
  bulkMarkReviewedReducer,
} from './reducers/auditTrailReducers.js'

// Manual Affiliate System reducers
import {
  playerAffiliatesReducer,
  assignAffiliateReducer,
  updateAffiliateAssignmentReducer,
  removeAffiliateAssignmentReducer,
  affiliateReferralsReducer,
  logSessionHoursReducer,
  playerSessionHoursReducer,
  voidSessionLogReducer,
  commissionTiersReducer,
  createCommissionTierReducer,
  updateCommissionTierReducer,
  deleteCommissionTierReducer,
  seedDefaultTiersReducer,
  commissionPreviewReducer,
  calculateCommissionReducer,
  pendingCommissionsReducer,
  approveCommissionReducer,
  rejectCommissionReducer,
  bulkApproveCommissionsReducer,
  potentialAffiliatesReducer,
} from './reducers/affiliateReducers.js'

// Manual KYC reducers
import {
  searchUsersKYCReducer,
  pendingKYCReducer,
  kycDetailsReducer,
  uploadKYCDocumentReducer,
  submitKYCReducer,
  approveKYCReducer,
  rejectKYCReducer,
} from './reducers/manualKYCReducer.js'

// Settings reducers
import { maintenanceStatusReducer } from './reducers/settingsReducer.js'
import { clubAccessStatusReducer } from './reducers/clubReducers.js'


const reducer = combineReducers({
  // User reducers
  userLogin: userLoginReducer,
  userLogout: userLogoutReducer,
  getRoleInfo: getRoleReducer,
  getUsersInfo: getUsersReducer,
  addUserInfo: addUserReducer,
  getUserByIDInfo: getUserByIDReducer,
  addCustomerToUserInfo: addCustomerToUserReducer,
  updateUserInfo: updateUserReducer,
  resetDeviceIDInfo: resetDeviceIDReducer,
  resetPasswordInfo: resetPasswordReducer,
  removeCustomerFromUserInfo: removeCustomerFromUserReducer,
  fetchAttendanceInfo: fetchAttendanceReducer,
  resignUserInfo: resignUserReducer,
  forceLogoutUserInfo: forceLogoutUserReducer,
  forceLogoutMultipleInfo: forceLogoutMultipleReducer,
  deleteAdminInfo: deleteAdminReducer,
  bulkDeleteAdminsInfo: bulkDeleteAdminsReducer,
  adminLogin: adminLoginReducer,
  addAdminInfo: addAdminReducer,
  getAdminsInfo: getAdminsReducer,
  getAdminByIDInfo: getAdminByIDReducer,
  updateAdminInfo: updateAdminReducer,
  getAffiliateStats: getAffiliateStatsReducer,
  getAffiliateReferrals: getAffiliateReferralsReducer,
  getAffiliateEarnings: getAffiliateEarningsReducer,

  // Customer reducers
  getCustomersInfo: getCustomersReducer,
  addCustomerInfo: addCustomerReducer,
  updateCustomerInfo: updateCustomerReducer,

  // Role reducers
  getRolesInfo: getRolesReducer,
  addRoleInfo: addRoleReducer,
  getRoleByIDInfo: getRoleByIDReducer,
  updateRoleInfo: updateRoleReducer,
  deleteRoleInfo: deleteRoleReducer,

  // wallet reducers
  getWalletBalance: getWalletBalanceReducer,
  getUserTransactions: getUserTransactionsReducer,
  createDeposit: createDepositReducer,
  createChipDeposit: createChipDepositReducer,
  createBuyIn: createBuyInReducer,
  // Table Reducers
  tableList: tableListReducer,
  tableDetails: tableDetailsReducer,
  tableCreate: tableCreateReducer,
  tableUpdate: tableUpdateReducer,
  tableDelete: tableDeleteReducer,


  getAllTransactions: getAllTransactionsReducer,
  updateTransactionStatus: updateTransactionStatusReducer,
  createAdminTransaction: createAdminTransactionReducer,
  getUsersForTransaction: getUsersForTransactionReducer,
  getClubLedger: getClubLedgerReducer,

  // Daily Commission (Rake) reducers
  addDailyCommission: addDailyCommissionReducer,
  getDailyCommissions: getDailyCommissionsReducer,
  getDailyCommissionById: getDailyCommissionByIdReducer,
  updateDailyCommission: updateDailyCommissionReducer,
  deleteDailyCommission: deleteDailyCommissionReducer,
  getCommissionSummary: getCommissionSummaryReducer,
  updateEvidenceStatus: updateEvidenceStatusReducer,
  bulkUpdateEvidenceStatus: bulkUpdateEvidenceStatusReducer,
  exportDailyCommissions: exportDailyCommissionsReducer,

  // ✅ ADD REPORT REDUCERS
  getReportsInfo: getReportsReducer,
  getDetailedTransactionsInfo: getDetailedTransactionsReducer,
  setReportFilterInfo: setReportFilterReducer,
  exportReportsInfo: exportReportsReducer,
  getAvailableClubsInfo: getAvailableClubsReducer,
  selectedClubs: selectedClubsReducer, // Multi-club selection state

  // Club and Location reducers
  venueList: venueListReducer,
  venueCreate: venueCreateReducer,
  venueAddClub: venueAddClubReducer,
  locationList: locationListReducer,
  locationDetails: locationDetailsReducer,
  locationCreate: locationCreateReducer,
  locationUpdate: locationUpdateReducer,
  locationDelete: locationDeleteReducer,
  clubList: clubListReducer,
  clubDetails: clubDetailsReducer,
  clubCreate: clubCreateReducer,
  clubUpdate: clubUpdateReducer,
  clubDelete: clubDeleteReducer,
  clubStats: clubStatsReducer,
  clubAssignAdmin: clubAssignAdminReducer,
  selectedClub: selectedClubReducer,

  // Chip Inventory reducers
  chipInventory: chipInventoryReducer,
  chipInventorySetup: chipInventorySetupReducer,
  chipInventoryAdd: chipInventoryAddReducer,
  chipInventoryRemove: chipInventoryRemoveReducer,
  chipInventoryHistory: chipInventoryHistoryReducer,
  chipInventorySummary: chipInventorySummaryReducer,
  chipInventoryReconcile: chipInventoryReconcileReducer,

  // Player Profile reducers
  playerProfile: playerProfileReducer,
  playerSummary: playerSummaryReducer,
  playerTransactions: playerTransactionsReducer,
  playerAnalytics: playerAnalyticsReducer,
  playerClubs: playerClubsReducer,
  playerReferrals: playerReferralsReducer,
  freezePlayer: freezePlayerReducer,
  playerPhone: playerPhoneReducer,
  listPlayers: listPlayersReducer,
  assignPlayerClub: assignPlayerClubReducer,
  removePlayerClub: removePlayerClubReducer,
  playerRemarks: playerRemarksReducer,
  updatePlayerRemarks: updatePlayerRemarksReducer,
  deletePlayer: deletePlayerReducer,
  bulkDeletePlayers: bulkDeletePlayersReducer,

  // Session Management reducers
  startSession: startSessionReducer,
  endSession: endSessionReducer,
  activeSession: activeSessionReducer,
  sessionSummary: sessionSummaryReducer,

  // Analytics Dashboard reducers
  transactionVolume: transactionVolumeReducer,
  revenueAnalytics: revenueAnalyticsReducer,
  userGrowth: userGrowthReducer,
  realTimeStats: realTimeStatsReducer,
  clubPerformance: clubPerformanceReducer,

  // Messaging reducers
  getMessagingUsersReducer: getMessagingUsersReducer,
  sendDirectMessageReducer: sendDirectMessageReducer,
  getMessageTemplatesReducer: getMessageTemplatesReducer,
  getUserMessageHistoryReducer: getUserMessageHistoryReducer,
  claimVoucher: claimVoucherReducer,
  getVoucherStatus: getVoucherStatusReducer,
  getMyVouchers: getMyVouchersReducer,


  // Manual Affiliate System reducers
  playerAffiliates: playerAffiliatesReducer,
  assignAffiliate: assignAffiliateReducer,
  updateAffiliateAssignment: updateAffiliateAssignmentReducer,
  removeAffiliateAssignment: removeAffiliateAssignmentReducer,
  affiliateReferralsList: affiliateReferralsReducer,
  logSessionHours: logSessionHoursReducer,
  playerSessionHours: playerSessionHoursReducer,
  voidSessionLog: voidSessionLogReducer,
  commissionTiers: commissionTiersReducer,
  createCommissionTier: createCommissionTierReducer,
  updateCommissionTier: updateCommissionTierReducer,
  deleteCommissionTier: deleteCommissionTierReducer,
  seedDefaultTiers: seedDefaultTiersReducer,
  commissionPreview: commissionPreviewReducer,
  calculateCommission: calculateCommissionReducer,
  pendingCommissions: pendingCommissionsReducer,
  approveCommission: approveCommissionReducer,
  rejectCommission: rejectCommissionReducer,
  bulkApproveCommissions: bulkApproveCommissionsReducer,
  potentialAffiliates: potentialAffiliatesReducer,

  // Dashboard reducers
  dashboardStats: dashboardStatsReducer,
  dashboardAdminStats: dashboardAdminStatsReducer,
  dashboardTutorials: dashboardTutorialsReducer,
  dashboardLiveFloor: dashboardLiveFloorReducer,
  dashboardActiveSessions: dashboardActiveSessionsReducer,
  dashboardDealerStatus: dashboardDealerStatusReducer,
  dashboardAlerts: dashboardAlertsReducer,
  dashboardRevenueChart: dashboardRevenueChartReducer,
  dashboardPlayerGrowth: dashboardPlayerGrowthReducer,
  dashboardClubRevenue: dashboardClubRevenueReducer,
  dashboardRecentTxn: dashboardRecentTxnReducer,
  dashboardPendingApprovals: dashboardPendingApprovalsReducer,
  dashboardHighlights: dashboardHighlightsReducer,

  // Audit Trail reducers
  auditLogs: auditLogsReducer,
  auditLogDetail: auditLogDetailReducer,
  auditLogStats: auditLogStatsReducer,
  pendingReviews: pendingReviewsReducer,
  markAsReviewed: markAsReviewedReducer,
  securityAlerts: securityAlertsReducer,
  userActivity: userActivityReducer,
  exportAuditLogs: exportAuditLogsReducer,
  bulkMarkReviewed: bulkMarkReviewedReducer,

  // Manual KYC reducers
  searchUsersKYC: searchUsersKYCReducer,
  pendingKYC: pendingKYCReducer,
  kycDetails: kycDetailsReducer,
  uploadKYCDocument: uploadKYCDocumentReducer,
  submitKYC: submitKYCReducer,
  approveKYC: approveKYCReducer,
  rejectKYC: rejectKYCReducer,

  // Settings reducers
  maintenanceStatus: maintenanceStatusReducer,
  clubAccessStatus: clubAccessStatusReducer,
});

// Get stored data from localStorage
const adminInfoFromStorage = localStorage.getItem('adminInfo')
  ? JSON.parse(localStorage.getItem('adminInfo'))
  : null;

const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

// Set initial state with both admin and user data
const inititalState = {
  adminLogin: { userInfo: adminInfoFromStorage },
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

// Conditionally apply Redux DevTools extension
const composeEnhancers = process.env.NODE_ENV === 'development'
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;

const store = createStore(
  reducer,
  inititalState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
